import { defineStyleConfig } from '@chakra-ui/react'

export const checkboxTheme = defineStyleConfig({
  defaultProps: {},
  baseStyle: {
    control: {
      width: '20px',
      height: '20px',
      border: '1px',
      borderRadius: '2px',
      borderColor: 'presets.turquoise.50',
      _checked: {
        borderColor: 'presets.turquoise.50',
        backgroundColor: 'presets.turquoise.50',
        _hover: {
          backgroundColor: 'presets.turquoise.50',
          borderColor: 'presets.turquoise.50',
        },
        _disabled: {
          color: 'white',
          backgroundColor: 'presets.neutral.40',
          borderColor: 'presets.neutral.40',
        },
      },
      _indeterminate: {
        backgroundColor: 'presets.turquoise.50',
        borderColor: 'presets.turquoise.50',
      },
      _disabled: {
        backgroundColor: 'presets.neutral.40',
        borderColor: 'presets.neutral.40',
      },
    },
    // label: {
    //   fontWeight: "500",
    //   fontSize: "14px",
    //   color: "presets.turquoise.100",
    // },
  },
})
